import { useMemo } from 'react';
import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

import { AccountDataSelectors, createAccountDataSelectors } from '@entities/account';
import { useApolloTypedClient } from '@shared/api/apolloClient';

const selectorsCache = new WeakMap<
  ApolloClient<NormalizedCacheObject>,
  ReturnType<typeof createAccountDataSelectors>
>();

export const useAccountSelectors = (): AccountDataSelectors => {
  const apolloClient = useApolloTypedClient();

  return useMemo(() => {
    if (selectorsCache.has(apolloClient)) {
      return selectorsCache.get(apolloClient)!;
    }

    const selectors = createAccountDataSelectors(apolloClient);

    selectorsCache.set(apolloClient, selectors);

    return selectors;
  }, [apolloClient]);
};
